import { z } from "zod/v4";

import type { Viewport } from "@xyflow/system";

import { LanguageModelSchema } from "../common";

export const NodeTypeList = [
  "llm-chat",
  "condition",
  "tool-execution",
  "user-input",
  "variable",
  "start",
  "llm-filter",
  "inject-context",
  "export",
  "llm-object",
] as const;

export const NodeTypeSchema = z.enum(NodeTypeList);

export const BaseNodeDefinitionSchema = z.object({
  id: z.string(),
  name: z.string(),
  description: z.string().optional(),
  nextNodeId: z.string().optional(),
});

export const BaseNodeDefinitionConfigSchema = z.object({
  model: LanguageModelSchema.nullish(),
});

export const BaseNodeErrorSchema = z.object({
  name: z.string(),
  message: z.string(),
});

export type NodeType = z.infer<typeof NodeTypeSchema>;

export type BaseNodeDefinition = z.infer<typeof BaseNodeDefinitionSchema> & {
  viewport: Viewport;
};
export type BaseNodeDefinitionConfig = z.infer<
  typeof BaseNodeDefinitionConfigSchema
>;
export type BaseNodeError = z.infer<typeof BaseNodeErrorSchema>;
